
<div [ngSwitch]="type">
    <app-form-radio-group *ngSwitchCase="'radio'" [options]="options" [skill]="skill"  (radioChanged$)="onValueChange($event)"></app-form-radio-group>
</div>